import { render, staticRenderFns } from "./DocumentDataExtractionSection.vue?vue&type=template&id=325d1832&scoped=true&"
import script from "./DocumentDataExtractionSection.vue?vue&type=script&lang=js&"
export * from "./DocumentDataExtractionSection.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDataExtractionSection.vue?vue&type=style&index=0&id=325d1832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325d1832",
  null
  
)

export default component.exports